export enum FAQCategory {
  ALL = 'all',
  ACCOUNT_ACCESS = 'account_access',
  ASSESSMENT_RESULTS = 'assessment_results',
  CUSTOMIZATION = 'customization',
  DATA_AND_INTEGRITY = 'data_and_integrity',
  DATA_EXPORT = 'data_export',
  DESIGN_A_SPRINT = 'design_a_sprint',
  FACILITATING_REFLECTIONS = 'facilitating_reflections',
  FEEDBACK_DEVELOPMENT = 'feedback_development',
  GAMER_PREPARATIONS = 'gamer_preparations',
  GENERATE_REPORT = 'generate_report',
  GETTING_STARTED = 'getting_started',
  IN_GAME = 'in_game',
  LICENSE_MANAGEMENT = 'license_management',
  MANAGE_SPRINTS = 'manage_sprints',
  ONBOARDING = 'onboarding',
  PRIVACY_DATA = 'privacy_data',
  SESSION_MANAGEMENT = 'session_management',
  TEAMS_AND_USERS = 'teams_and_users',
  TECHNICAL_SUPPORT = 'technical_support',
  TESTING = 'testing',
  TROUBLESHOOTING = 'troubleshooting'
}

export interface FAQItem {
  id: string
  questionKey: string // Translation key for the question
  descriptionKey: string // Translation key for the answer/description
  categories: FAQCategory[] // Multiple categories supported
}

export interface FAQGuideCard {
  id: string
  icon: string
  title: string
  description: string
  buttonText: string
  buttonAction: () => void
  buttonIcon?: string
}
